import { useQuery } from '@tanstack/react-query';
import { listDrafts } from 'shared/api/shipment';

// Independent of features/drafts/queries.ts's own useDrafts query on purpose: this hook is
// consumed outside that feature too (layout's nav badge, features/shipments's stat card), so
// it depends on shared/api directly rather than reaching into another feature. A different
// query key means the two don't share a cache entry — a second request when both the badge
// and the drafts list are mounted at once, same as today (this hook and the old drafts view
// already ran two independent fetches; TanStack Query at least caches each one now).
export const draftCountKeys = { all: ['drafts', 'count'] as const };

const useDraftCount = (enabled = true) => {
  const query = useQuery({
    queryKey: draftCountKeys.all,
    enabled,
    queryFn: async () => {
      const res = await listDrafts();
      const payload = res?.data as unknown[] | { data?: unknown[]; results?: unknown[] } | undefined;
      const drafts = Array.isArray(payload) ? payload : payload?.data || payload?.results || [];
      return drafts.length;
    }
  });

  return { count: query.data ?? null, loading: query.isLoading, refresh: query.refetch };
};

export default useDraftCount;
